// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"488":"22347b02424330e2242e","532":"8bbf4a81c065a9b9699d","569":"a4cd5cb33709778c9049","592":"8a99d4168763560167e8","736":"66d8508d9b06ef36e7f2"}[chunkId] + ".js";
};